



























import { Component, Vue } from "vue-property-decorator";
import CardMenu from "../../components/CardMenu.vue";
import { CardMenuItem } from "../../interfaces/card-menu.interface";
import TranslationApiAgent from "../../services/translation-api-agent";
import Editor from '../../components/Editor.vue';
import GalleryApiAgent,{ Image } from '@/services/gallery-api-agent';

// @ts-ignore
@Component()
export default class AdminGalleryEdit extends Vue {
	private activeStr: string = this.translationsApiAgent.get('active');
  private sendStr: string = this.translationsApiAgent.get('send');
  private uploadStr: string = this.translationsApiAgent.get('admin::gallery::upload');
	private titleStr: string = this.translationsApiAgent.get('admin::page::title');
	private response: string = '';

	private pages: CardMenuItem[] = [];
  private title: string = '';
  private images: Image[] = [];
  private formData: FormData;

  constructor(
    private galleryApiAgent = GalleryApiAgent,
		private translationsApiAgent = TranslationApiAgent
  ) {
    super();
	}

	get id() {
		return this.$route.params.id;
	}

	get isNew() {
		return this.id === 'new';
  }

  get isEmpty() {
    return this.images.length === 0;
  }

  mounted() {
		if (!this.isNew) {
      this.title = this.id;
      this.galleryApiAgent.list(this.id).then(imgs => {
        this.images = imgs;
      });
		}
	}

	private remove() {
		const answer = confirm(this.translationsApiAgent.get('admin::remove-question'));
		if (answer) {
			this.galleryApiAgent.remove(this.id).then(result => {
				this.$router.push({
					path: '/admin/galleries'
				});
			});
		}
  }

  private removeImage(img: Image) {
    const answer = confirm(this.translationsApiAgent.get('admin::remove-question'));
		if (answer) {
      this.galleryApiAgent.removeImage(this.id, img.name).then(() => {
        this.images = this.images.filter(i => i.name !== img.name);
      });
    }
  }

	private send() {
		if (this.isNew) {
			this.galleryApiAgent.add(this.title).then(() => {
        this.$router.push({
          path: '/admin/gallery/' + this.title
        });
			});
		}
		else {
			this.galleryApiAgent.update(this.id, this.title).then(result => {
        this.response = this.translationsApiAgent.get(result ? 'admin::save-success' : 'admin::save-fail');
        this.$router.push({
          path: '/admin/gallery/' + this.title
        });
			});
		}
  }

  private addFile(event: Event) {
    const fileList = (event.target as HTMLInputElement).files;
    const fieldName = (event.target as HTMLInputElement).name;

    const formData = new FormData();

    if (!fileList.length) return;

    // append the files to FormData
    [...Array(fileList.length).keys()]
      .map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });

    // save it
    this.formData = formData;
  }

  private upload() {
    this.galleryApiAgent.upload(this.id, this.formData).then(res => {
      this.galleryApiAgent.list(this.id).then(imgs => {
        this.images = imgs;
      });
    });
  }
}
